import { render, staticRenderFns } from "./SnapRegistration.vue?vue&type=template&id=5c8e02b6"
import script from "./SnapRegistration.vue?vue&type=script&lang=js"
export * from "./SnapRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports